import type { PldaGridItem, PldaStatus } from "@services/plda/types";
import { format } from "date-fns";
import type { TFunction } from "i18next";

const LANG_BASE = "vessel-call.operations.plda-grid";
const DATE_TIME_FORMAT = "dd/MM/yyyy HH:mm";
const PLDA_DISPLAY_STATUS: Record<PldaStatus, "PENDING" | Exclude<PldaStatus, "SUBMITTED">> = {
  SUBMITTED: "PENDING",
  READY: "READY",
  REJECTED: "REJECTED",
  CANCELLED: "CANCELLED",
};

export type PldaBadgeType = "success" | "warning" | "error";

type PldaDateField =
  | "pldaSubmitted"
  | "vesselNor"
  | "allCustomerAcceptance"
  | "fottApproved"
  | "masterSignature";

export type PldaGridRow = Omit<PldaGridItem, "status" | PldaDateField> & {
  id: string;
  pldaSubmitted: string;
  vesselNor: string;
  allCustomerAcceptance: string;
  fottApproved: string;
  masterSignature: string;
  status: string;
  badgeType: PldaBadgeType;
};

const formatPldaDateTime = (value?: string | null): string => {
  if (!value) return "-";

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : format(date, DATE_TIME_FORMAT);
};

const getStatusBadgeType = (status: PldaStatus): PldaBadgeType => {
  switch (status) {
    case "READY":
      return "success";
    case "REJECTED":
    case "CANCELLED":
      return "error";
    case "SUBMITTED":
      return "warning";
  }
};

export const mapPldaGridItem = (item: PldaGridItem, t: TFunction): PldaGridRow => ({
  ...item,
  id: item.pldaId,
  pldaSubmitted: formatPldaDateTime(item.pldaSubmitted),
  vesselNor: formatPldaDateTime(item.vesselNor),
  allCustomerAcceptance: formatPldaDateTime(item.allCustomerAcceptance),
  fottApproved: formatPldaDateTime(item.fottApproved),
  masterSignature: formatPldaDateTime(item.masterSignature),
  status: t(`${LANG_BASE}.statuses.${PLDA_DISPLAY_STATUS[item.status]}`),
  badgeType: getStatusBadgeType(item.status),
});
